import { ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const EmptyChartMessage: FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <ZfTypography variant="label-large" style={{ padding: 'var(--padding-vertical-xl) 0' }}>
            {t('wealthCreateTableEntriesToDisplayChartsMessage')}
        </ZfTypography>
    );
};
